"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorsToJSON = exports.ErrorsFromJSONTyped = exports.ErrorsFromJSON = exports.instanceOfErrors = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Errors interface.
 */
function instanceOfErrors(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfErrors = instanceOfErrors;
function ErrorsFromJSON(json) {
    return ErrorsFromJSONTyped(json, false);
}
exports.ErrorsFromJSON = ErrorsFromJSON;
function ErrorsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : json['errors'],
        'executionError': !(0, runtime_1.exists)(json, 'execution_error') ? undefined : json['execution_error'],
    };
}
exports.ErrorsFromJSONTyped = ErrorsFromJSONTyped;
function ErrorsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errors': value.errors,
        'execution_error': value.executionError,
    };
}
exports.ErrorsToJSON = ErrorsToJSON;
